import { Schema } from 'effect';

// Curated public document metadata used by both:
//   - Blog.GetPost (sidebar "Public Documents" promotions)
//   - PublicDoc.GetDocMetadata (single doc metadata lookup)
//
// Mirrors the static catalog shape in
// `@listening/backend/public-doc-catalog`.
export const PublicDocPromotion = Schema.Struct({
  metadata: Schema.Struct({
    title: Schema.String,
    abstract: Schema.String,
    authors: Schema.String,
    publication_date: Schema.String,
    citation_count: Schema.Int,
    category: Schema.optional(Schema.String),
    copyright_text: Schema.String,
    g_drive_link: Schema.String,
    listing_url: Schema.String,
    source: Schema.String,
  }),
  audioConversion: Schema.Struct({
    id: Schema.String,
    publicId: Schema.optional(Schema.String),
    status: Schema.String,
    cover_img: Schema.optional(Schema.String),
    visibility: Schema.optional(Schema.String),
  }),
});
